import React, { useState } from 'react';
import { VideoPlayer } from './VideoPlayer';
import { TimelinePanel } from './TimelinePanel';
import styles from '../NewNG.module.css';

interface TimeLinedVideoProps {
  jobId: string;
  networkName?: string;
  onJobChange?: (jobId: string) => void;
}

export const TimeLinedVideo: React.FC<TimeLinedVideoProps> = ({ jobId, networkName = 'FEI', onJobChange }) => {
  const [videoHeight, setVideoHeight] = useState<number>(600); // Increased default height

  const handleVideoHeightChange = (height: number) => {

    setVideoHeight(Math.max(height, 500)); // Ensure minimum height of 500px
  };

  return (
    <div className={styles['newng-timelined-video']}>
      <div className={styles['newng-timelined-video-content']}>
        <div className={styles['newng-timelined-video-player']}>
          <VideoPlayer jobId={jobId} onHeightChange={handleVideoHeightChange} networkName={networkName} />
        </div>
        <div
          className={styles['newng-timelined-timeline']}
          style={{ height: `${videoHeight}px` }}
        >
          <TimelinePanel />
        </div>
      </div>
    </div>
  );
};